// First-party referral capture (docs/TMS_CONNECTION_PLAN_2026-10-06.md section 9, D18).
// A valid ?ref= code is kept in this browser only, for 30 days; the first code wins until it
// expires. Stored data is untrusted and re-validated on every read. Renders nothing.
const KEY = "mi.ref.v1";
const CODE = /^[A-Za-z0-9_-]{1,64}$/;
const TTL_MS = 30 * 86400000;
const PATH_MAX = 300;

let installed = false;

function storage() {
  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
}

function valid(record, now) {
  return (
    Boolean(record) &&
    typeof record === "object" &&
    typeof record.code === "string" &&
    CODE.test(record.code) &&
    Number.isSafeInteger(record.capturedAt) &&
    record.capturedAt <= now &&
    now - record.capturedAt < TTL_MS &&
    typeof record.landingPath === "string" &&
    record.landingPath.startsWith("/") &&
    record.landingPath.length <= PATH_MAX
  );
}

// The valid, unexpired referral { code, capturedAt, landingPath }, or null. An expired or
// malformed record is removed so a later ?ref= can be stored.
export function current(now = Date.now()) {
  const store = storage();
  if (!store) return null;
  let record = null;
  try {
    const raw = store.getItem(KEY);
    if (raw === null) return null;
    record = JSON.parse(raw);
  } catch {}
  if (valid(record, now))
    return {
      code: record.code,
      capturedAt: record.capturedAt,
      landingPath: record.landingPath,
    };
  try {
    store.removeItem(KEY);
  } catch {}
  return null;
}

// Stores ?ref= from the current URL unless an unexpired code is already stored.
export function capture(now = Date.now()) {
  let code = null;
  try {
    code = new URLSearchParams(window.location.search).get("ref");
  } catch {}
  if (typeof code !== "string" || !CODE.test(code) || current(now)) return;
  const record = {
    code,
    capturedAt: now,
    landingPath: (window.location.pathname || "/").slice(0, PATH_MAX),
  };
  if (!record.landingPath.startsWith("/")) return;
  try {
    storage()?.setItem(KEY, JSON.stringify(record));
  } catch {}
}

// Once per full page load, next to installRuntimeMonitoring() in src/index.js.
export function install() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  try {
    capture();
  } catch {}
}
